var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FloatingPanel',[_c('div',{staticClass:"shop::canvas-blocks-shop-overlappingCategories-LoopPanel"},[_c('SwitchInput',{attrs:{"label":"Aantal kolommen","instruction":"Kies hier het aantal kolommen per rij.","items":[
                { value: 2 },
                { value: 3 } ],"options":_vm.options,"defaultValue":3,"options-property":"columnsCount","open":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }